<template>
  <div class="container">
    <div class="menu">
      <div class="left">
        <title2 :title="homePageData.moduleName"></title2>
        <div class="hh">
          <div class="item" :style="{backgroundImage:'url('+item.coverPath+')'}" v-for="(item,i) in imgList" :class="{active: i == imgIndex}" @mouseenter="imgIndex = i" @click="goDeatil2(item.id)"></div>
        </div>
      </div>
      <div class="right">
        <div class="h">{{homePageData2.moduleName}}</div>
        <div class="link">
          <div class="link-item hvr-pulse" v-for="(item,i) in iconList"  @click="goDeatil2(item.id)" v-if="i< 10">
            <div class="icon" :style="{backgroundImage:'url(' + item.coverPath + ')'}"></div>
            <div class="name" v-html="item.label"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import  { getCatalogList, getResourceList } from "@/api/index/index.js";

import title2 from './indexTitle2'
export default {
  name: "characteristic",

  props:['homePageData','homePageData2'],

  data(){
    return{
      imgList:[],
      imgIndex:0,
      iconList:[],
    }
  },
  components: {title2},
  mounted() {
    this.getdata()
  },
  methods:{
    getdata(){
      getCatalogList({featuredId: this.homePageData.id}).then(res=>{
        this.imgList = res.data
      })
      getCatalogList({featuredId: this.homePageData2.id}).then(res=>{
        this.iconList = res.data
      })
    },
    goDeatil2(id){
      getResourceList({featuredId: this.homePageData2.id,catalogId:id}).then(res=>{
        this.$router.push({
          path: "/special/specialDetail",
          query: { subjectId: res.data[0].id },
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container{
  /* 弹性布局 默认水平排列 */
  width: 1400px;
  margin: 0 auto;
  /* 溢出隐藏 */
  .menu{
    display: flex;
    justify-content: space-between;
    .left{
      width: 1019px;
      .hh{
        margin-top: 25px;
        display: flex;
        width: 1019px;
        overflow: hidden;
        height: 320px;
      }
    }
    .right{
      width: 360px;
      .h{
        line-height: 45px;
        font-size: 30px;
        background-color: #128bff;
        text-align: center;
        border-radius: 0 12px 0 12px;
        color: #fff;
      }
      .link{
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .link-item{
          display: flex;
          cursor: pointer;
          align-items: center;
          margin-bottom: 11px;
          width: 170px;
          height: 56px;
          border: 1px solid #128bff;
          font-size: 18px;
          .icon{
            width: 38px;
            height: 40px;
            margin: 0 20px;
            background-size: 100% 100%;
          }
          .name{
            text-align: center;
          }
          &:nth-child(9),&:nth-child(10){
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.item{
  /* 相对定位 */
  position: relative;
  width: 100px;
  margin-left: 10px;
  cursor: pointer;
  /* 保持原有尺寸比例，裁切长边 */
  background-size: cover;
  /* 定位背景图像为正中间 */
  background-position: left;
  /* 过渡效果：时长 贝塞尔曲线 */
  transition: 1s cubic-bezier(0.05,0.61,0.41,0.95);
  overflow: hidden;
  &:first-of-type{
    margin: 0;
  }
}

.item:nth-child(1) .fa{
  color: #fc6e51;
}
.item:nth-child(2) .fa{
  color: #ffce54;
}
.item:nth-child(3) .fa{
  color: #2ecc71;
}
.item:nth-child(4) .fa{
  color: #5d9cec;
}
.item:nth-child(5) .fa{
  color: #ac92ec;
}
/* 选中态样式 */
.item.active{
  width: 689px;
}
</style>